/**
 * Replaces the Bold currency picker
 */

const select = document.querySelectorAll('[name="currency"]');

select.forEach((elem) =>
  elem.addEventListener("change", () => {
    elem.parentElement.submit();
  })
);
